<div class="pagecontent">
    <form [formGroup]="postTripRequestForm">
        <mat-horizontal-stepper [selectedIndex]="activeStepperIndex" animationDuration="0ms" #stepper >
            <mat-step>
                <ng-template matStepLabel>Appointment Date</ng-template>
                <app-appointment [tripType]="'Post'"></app-appointment>
                <div class="appointment-button">
                    <button type="button"  mat-button (click)="goToDriverInfo(stepper, 'Next')">Next</button>
                </div>               
            </mat-step>
            <mat-step>
                <ng-template matStepLabel>Driver Information</ng-template>
                <app-trip-driver></app-trip-driver>
                <div class="button-container">
                    <div class="left-button">
                        <button type="button"   mat-button (click)="goToAppointment(stepper)">Back</button></div>
                    <div class="right-button">
                        <button type="button"   mat-button (click)="goToTripLocation(stepper, 'Next')">Next</button>
                    </div>                   
                </div>
            </mat-step>
            <mat-step>
                <ng-template matStepLabel>Trip Location</ng-template>
                <app-trip-location></app-trip-location>
                <div class="button-container">
                    <div class="left-button">
                        <button type="button"  mat-button (click)="goToDriverInfo(stepper, 'Back')">Back</button></div>
                    <div class="right-button">
                        <button type="button"   mat-button (click)="goToPassenger(stepper, 'Next')">Next</button>
                    </div>                   
                </div>
            </mat-step>
            <mat-step>
                <ng-template matStepLabel>Passenger Information</ng-template>
                <app-trip-passenger></app-trip-passenger>
                <div class="button-container">
                    <div class="left-button">
                        <button type="button"   mat-button (click)="goToTripLocation(stepper, 'Back')">Back</button></div>
                    <div class="right-button">
                        <button type="button"   mat-button (click)="goToDocuments(stepper, 'Next')">Next</button>
                    </div>                   
                </div>
            </mat-step>
            <mat-step>
                <ng-template matStepLabel>Document Upload</ng-template>
                <app-trip-document></app-trip-document>
                <div class="button-container">
                    <div class="left-button">
                        <button type="button"  mat-button (click)="goToPassenger(stepper, 'Back')">Back</button></div>
                    <div class="right-button">
                        <button type="button"   mat-button (click)="goToSummary(stepper, 'Next')">Next</button>
                    </div>                   
                </div>
            </mat-step>
            <mat-step>
                <ng-template matStepLabel>Summary</ng-template>
                <app-trip-summary [tripType]="'Post'"></app-trip-summary>
                <div class="button-container">
                    <div class="left-button">
                        <button type="button"  mat-button (click)="goToDocuments(stepper, 'Back')">Back</button></div>
                    <div class="right-button">
                        <button type="submit"   mat-button (click)="saveTripSumary()">Submit</button>
                    </div>                   
                </div>
            </mat-step>
        </mat-horizontal-stepper>
    </form>
</div>

<ng-template #confirmationDialogTemplate>
  <div class="access-dialogue">
     <div mat-dialog-title class="dialog-title-center">
        <span>{{dialogTitle}}</span>
    </div>
    <mat-dialog-content>
      <p>{{dialogContent}}</p>
    </mat-dialog-content>
    <mat-dialog-actions class="dialog-actions-center">
      <button mat-flat-button color="primary" (click)="closeDialog()" aria-label="Continue to next step">OK</button>
    </mat-dialog-actions>
  </div>
</ng-template>